module.exports = __webpack_public_path__ + "static/media/b-sci-major-28_LR.15e8d9e5.jpg";